import { Navigate } from "react-router-dom";

/** Legacy-Einstieg: leitet auf den ersten Auswertungs-Bereich weiter. */
export function AuswertungenIndexPage() {
  return <Navigate to="/auswertungen/hero-zeiten" replace />;
}
